import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { CalendarClock } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

export const JoiningReminderPopup = () => {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const load = useCallback(() => {
    axios.get(`${API}/api/joining-reminders/pending`).then(r => setItems(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 5 * 60000);
    return () => clearInterval(t);
  }, [load]);

  const ack = async (go) => {
    const ids = items.map(i => i.id);
    setItems([]);
    await axios.post(`${API}/api/joining-reminders/ack`, { ids }).catch(() => {});
    if (go) navigate('/onboarding');
  };

  return (
    <Dialog open={items.length > 0} onOpenChange={o => { if (!o) ack(false); }}>
      <DialogContent className="max-w-md" data-testid="joining-reminder-popup">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><CalendarClock className="h-5 w-5 text-violet-600" /> Joining soon</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-gray-600">These candidates accepted their offer and join within a week. Make sure visa, documents and assets are ready.</p>
        <div className="space-y-2 max-h-72 overflow-y-auto">
          {items.map(i => (
            <div key={i.id} className="flex items-center justify-between rounded-md border px-3 py-2" data-testid={`joining-reminder-${i.id}`}>
              <div>
                <p className="text-sm font-semibold">{i.candidate_name}</p>
                <p className="text-[11px] text-gray-500">{i.position || '—'}{i.department ? ` · ${i.department}` : ''} · {i.expected_join_date}</p>
              </div>
              <span className="text-xs font-bold text-violet-700 bg-violet-50 rounded-full px-2 py-0.5">
                {i.days_left === 0 ? 'Today' : `${i.days_left}d`}
              </span>
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => ack(false)} data-testid="joining-reminder-dismiss">Got it</Button>
          <Button onClick={() => ack(true)} data-testid="joining-reminder-open">Open Onboarding</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
